import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error-message"
}
const _hoisted_2 = { class: "error-message__icon" }
const _hoisted_3 = { class: "error-message__content" }
const _hoisted_4 = { class: "error-message__content-title" }
const _hoisted_5 = { class: "error-message__content-text" }
const _hoisted_6 = { class: "row gap-2" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "tasks" }

import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import FloatingCard from '@/components/common/floating-card/FloatingCard.vue';
import NavHeader from '@/components/common/nav-header/NavHeader.vue';
import UserIcon from '@/components/Home/UserIcon.vue';
import RouteNames from '@/configuration/router/names.routes';
import { ErrorWithToastData } from '@/exceptions/ErrorWithToastData';
import { AuthMethods } from '@/models/auth-methods';
import { TaskRegistry } from '@/models/tasks.models';
import moduleAvailabilityService from '@/services/ModuleAvailabilityService';
import navigationService from '@/services/NavigationService';
import { useAuthStore } from '@/stores/authStore';
import { useToasterStore } from '@/stores/useToasterStore';
import { DocumentValidationUtils } from '@/utils/document-validation.utils';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import TaskCard from '../components/common/task-card/TaskCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const { t } = useI18n();
const toaster = useToasterStore();
const authStore = useAuthStore();

const tasks = computed(() => {
  // Get modules supported on the current platform
  const supportedModules = moduleAvailabilityService.getSupportedModules();

  return supportedModules.map((moduleKey) => {
    const task = TaskRegistry.tasks[moduleKey];
    const isAvailable = moduleKey in authStore.products.modules;

    return {
      ...task,
      disabled: !isAvailable
    };
  });
});

const userHasNoProducts = computed(() => {
  return !tasks.value.length || tasks.value.every((task) => task.disabled);
});

async function validateReviewRequirements() {
  await DocumentValidationUtils.validateReviewRequirements(t);
}

async function validateTaskRequirements(routeName: string) {
  if (!routeName) return;

  switch (routeName) {
    case RouteNames.Reviewing: {
      await validateReviewRequirements();
      break;
    }
    // TODO: restrict other cases for deployment needs
    default:
      break;
  }
}

async function handleTask(routeName: string | undefined) {
  try {
    if (routeName) {
      await validateTaskRequirements(routeName);
      navigationService.navigateTo({ name: routeName });
    } else {
      throw new Error('Task not implemented');
    }
  } catch (error) {
    const toast =
      error instanceof ErrorWithToastData
        ? { title: error.message, body: error.body }
        : {
            title: t('contextual_errors.unknown.title'),
            body: t('contextual_errors.unknown.body')
          };

    toaster.error(toast);
    console.error(error);
  }
}

function onClickSettings() {
  navigationService.navigateTo({ name: RouteNames.UserSettings });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (userHasNoProducts.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(AppIcon, {
              name: "warning",
              size: "headline-m"
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('home.error_title_insufficient_permissions')), 1),
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_unref(t)('home.error_body_insufficient_permissions')) + " ", 1),
              _createElementVNode("u", null, _toDisplayString(_unref(t)('home.error_body_insufficient_permissions.admin')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(NavHeader, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(AppIcon, {
            name: "settings",
            size: "body-xl",
            "class-name": "color-lighter",
            clickable: true,
            onClick: onClickSettings
          }),
          _createVNode(UserIcon)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("header", {
      class: _normalizeClass(["header", {
      'disabled-text': userHasNoProducts.value
    }])
    }, [
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('home.welcome')), 1),
      (_unref(authStore).authMethod !== _unref(AuthMethods).FranceMock)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(t)('home.description')), 1))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("main", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tasks.value, (task, index) => {
        return (_openBlock(), _createBlock(TaskCard, {
          key: index,
          icon: task.icon,
          title: task.title,
          description: task.description,
          disabled: task.disabled,
          onClick: ($event: any) => (handleTask(task.routeName))
        }, null, 8, ["icon", "title", "description", "disabled", "onClick"]))
      }), 128)),
      (!tasks.value || tasks.value.length === 0)
        ? (_openBlock(), _createBlock(FloatingCard, {
            key: 0,
            class: "no-tasks"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_unref(t)('home.no_tasks_message')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})